import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './MagicLinkSent.css'

const MagicLinkSent: React.FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const email = location.state?.email || 'your email'

    return (
        <div className="magic-link-sent-container">
            <div className="magic-link-sent-card">
                <div className="icon-wrapper">
                    <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        className="email-icon"
                    >
                        <circle cx="32" cy="32" r="32" fill="#d1fae5" />
                        <path
                            d="M16 24l16 12 16-12M16 40h32V24H16v16z"
                            stroke="#10b981"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill="none"
                        />
                        <circle cx="48" cy="20" r="6" fill="#10b981" />
                        <path
                            d="M46 20l1.5 1.5L50 19"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h1>Check your email</h1>

                <p className="main-text">
                    We've sent a magic link to <strong>{email}</strong>
                </p>

                <p className="sub-text">
                    Click the link in the email to access the API documentation.
                    The link will expire in 24 hours.
                </p>

                <div className="info-box">
                    <div className="info-item">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span>Check your spam folder if you don't see it</span>
                    </div>
                    <div className="info-item">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span>The link can only be used once</span>
                    </div>
                    <div className="info-item">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span>Your session will last 7 days</span>
                    </div>
                </div>

                <button
                    onClick={() => navigate('/')}
                    className="back-button"
                >
                    Back to login
                </button>

                <p className="footer-text">
                    Didn't receive the email? Check your email address and try again.
                </p>
            </div>
        </div>
    )
}

export default MagicLinkSent
